import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IState, appealAdapter, appealFeatureKey } from './appeal.reducers';
import { createQueryParamsWithPagination } from '../../../shared/utils';
import { IAppealFilter } from './appeal.interface';

const selectFeature = createFeatureSelector<IState>(appealFeatureKey);

const { selectAll } = appealAdapter.getSelectors(selectFeature);

const selectError = createSelector(selectFeature, (state) => state.error);

const selectLoading = createSelector(selectFeature, (state) => state.loading);

const selectAppealFilter = createSelector(
	selectFeature,
	(state) => state.filter,
);

const selectAppealFilterRequest = createSelector(selectAppealFilter, (state) =>
	createQueryParamsWithPagination<IAppealFilter>(state),
);

const selectSelectedAppeal = createSelector(
	selectFeature,
	(state) => state.selectedAppeal,
);

const selectContestedDecision = createSelector(
	selectFeature,
	(state) => state.contestedDecision,
);

const selectContestedCase = createSelector(
	selectFeature,
	(state) => state.contestedCase,
);

export const AppealSelectors = {
	selectAll,
	selectError,
	selectLoading,
	selectAppealFilter,
	selectAppealFilterRequest,
	selectSelectedAppeal,
	selectContestedDecision,
	selectContestedCase,
};
